import {AddDashboardWidgetService} from "./service/AddDashboardWidgetService";
import {addDashboardWidgetDialog, AddDashboardWidgetDialog} from "./components/AddDashboardWidgetDialog";

export default function() {
    return angular.module("tfApp.dashboard.oms.dialog.add-widget", [])
        .service(AddDashboardWidgetService.id, AddDashboardWidgetService)
        .component(AddDashboardWidgetDialog, addDashboardWidgetDialog())
        .name;
}
